import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      roomMeeting, // via withQuery
      setModal // via redux actions
    } = props

    const handleClickCard = e => {
      setModal({
        open: true,
        id: `room-meeting-${roomMeeting.id}`
      })
    }

    return <WrappedComponent onClickCard={handleClickCard} {...props} />
  }
}

export default withEventHandlers
